import { AccountInfo } from '@azure/msal-browser';
import { get } from 'lodash';

export function getClaim(account: AccountInfo, claim: string): string {
  return get(account, ['idTokenClaims', claim], '') as string;
}

export function getFullName(account: AccountInfo): string {
  const given_name = getClaim(account, 'given_name');
  const family_name = getClaim(account, 'family_name');
  const fullName = `${given_name}${given_name && family_name ? ' ' : ''}${family_name}`;
  return fullName || 'Unknown';
}
